import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

export default class extends Controller {
  static targets = ['boxberryPointForm']
  static values = {
    pointsPath: String,
  }

  changeCity(event) {
    const selectElement = event.target
    const selectedOption = selectElement.options[selectElement.selectedIndex]

    const formData = new FormData(this.form)
    formData.append(
      'boxberry_point_form[city_name]',
      selectedOption.textContent
    ) // Look into the app/forms/boxberry_point_form class for details

    post(this.pointsPathValue, {
      body: formData,
      responseKind: 'turbo-stream',
    })
  }

  get form() {
    return this.boxberryPointFormTarget
  }
}
